import {useEffect} from "react";
import PropTypes from 'prop-types';
import noop from "../utils/noop";
import useCreateScrapingCode from "../hooks/useCreateScrapingCode";
import useScrapingCode from "../hooks/useScrapingCode";
import {useTranslation} from "react-i18next";
import {useToaster} from "../context-providers/ToasterProvider";
import { ScrapingCodeFormModal as FormModal } from "../components/ScrapingCodeFormModal";

const model = {
    id: 0,
    is_active: 1,
    code: "",
    description: "",
    description2: "",
};

export const ScrapingCodeFormContainer = ({onCancelClick, onSave, recordId, onGetError}) => {
    
    const {t} = useTranslation("ScrapingCodeFormContainer");
    const { toastError, toastSuccess } = useToaster();
    
    const { isLoading, isFetching, error, data } =  useScrapingCode({
        recordId,
        placeholder: model});
    
    useEffect( ( ) => {
        if ( error ) {
            toastError(t("getCodeDataError"));
        }
    }, [error] );
    
    const { mutate: createRecord, isLoading: isSavingArea } = useCreateScrapingCode({
        onError: err => toastError(t("saveCodeError")),
        onSuccess: () => {
            toastSuccess(t("saveCodeSuccess"));
            onSave();
        }
    });
    
    const handleSaveClick = (values, actions) => {
        const data = {
            ...values,
            is_active: values.is_active ? 1 : 0
        };

        if ( data.id === 0 ) {
            delete data.id;
        }
        createRecord(data);
    };
    
    return (
        <>
            <FormModal show={true}
               loading={isLoading || isFetching || isSavingArea}
               record={data ?? model}
               onClose={onCancelClick}
               onSaveClick={handleSaveClick} onCancelClick={onCancelClick} />
       </>
    );
};

ScrapingCodeFormContainer.propTypes = {
    onClose: PropTypes.func,
    onCancelClick: PropTypes.func,
    onSave: PropTypes.func,
    onGetError: PropTypes.func
};

ScrapingCodeFormContainer.defaultProps = {
    onClose: noop,
    onCancelClick: noop,
    onSave: noop,
    onGetError: noop
};

export default ScrapingCodeFormContainer;